<template>
        <div class="vx-row">
            <div class="vx-col sm:w-full md:w-full mx-auto self-center">
                <div class="vx-row flex vs-align-center">
                    <div class="vx-col lg:w-1/3 md:w-full sm:w-full w-full mb-base">
                        <vx-card title="Núcleo">
                            <vue-vimeo-player player-width="100%" ref="player" v-bind="playerOptions"/>
                        </vx-card>
                    </div>
                    <div class="vx-col lg:w-2/3 md:w-full sm:w-full w-full mb-base">
                        <vx-card title="Módulos">
                            <vs-collapse :type="type" accordion="true">
                                <vs-collapse-item :key="tr.id" v-for="(tr) in moduleGroup.modules" :disabled="!tr.hasAccess">
                                    <div slot="header">
                                        {{ tr.nome }}
                                    </div>
                                    <vs-button color="primary" type="filled" class="mr-2 ml-5">Plano de curso</vs-button>
                                    <vs-button color="success" type="filled" class="mr-2">Conteúdo digital</vs-button>
                                    <vs-button color="danger" type="filled">Conteúdo híbrido</vs-button>
                                </vs-collapse-item>
                            </vs-collapse>
                        </vx-card>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import { mapState } from 'vuex'
import { getModuleGroup } from '../../_services/formations.service.js'

import { vueVimeoPlayer } from 'vue-vimeo-player'
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
    data: function() {
     return {
        moduleGroup: {},
        playerOptions: {
            videoId: "479773835",
            playerWidth: undefined,
            playerHeight: undefined,
            options: {
                responsive: true
            }
        }
     }  
    },
    created() {
        this.fetchModuleGroup()
    },
    watch: {
        $route() {
            this.fetchModuleGroup()
        }
    },
    methods: {
        async fetchModuleGroup() {
            this.moduleGroup = await getModuleGroup({studentId: this.account.user.student.id, moduleGroup: this.$route.params.id})
            this.$emit("changeRouteTitle", this.moduleGroup.nome);
        }
    },

    computed: {
        ...mapState({
            account: state => state.account
        })
    },
    components: {
        vueVimeoPlayer,
        VuePerfectScrollbar,
    },
    
};
</script>
